import { Box, Card, CardHeader, Stack, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints, useSettings } from "../../../hooks";
import { InfoOutlined } from "@mui/icons-material";
import { UserStrategyFilterButton } from "../../UserPages/UserStrategyPage/UserStrategyFilterButton";
import { UserStrategicOwnershipContent } from "../../UserPages/UserStrategyPage/UserStrategicOwnershipContent";

interface IProps {
  userGuid: string;
}

const UserStrategicOwnershipAgendaStep = (props: IProps) => {
  const { userStrategySettings, updateUserStrategySettings } = useSettings();
  const { isMdUp } = useBreakpoints();
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    handleViewToggled(userStrategySettings[props.userGuid]?.tableView ?? true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(userStrategySettings[props.userGuid]?.tableView ?? true);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, props.userGuid, userStrategySettings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateUserStrategySettings(props.userGuid, {
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card sx={{ p: 1 }}>
        <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Stack>
            <Typography variant="h5">Strategy</Typography>
            <Typography>Personal ownership of strategic items</Typography>
          </Stack>
          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </Stack>
      </Card>
      <Card>
        <CardHeader
          title={
            <Stack direction="row" spacing={0.25} sx={{
              flexGrow: 1
            }}>
              <Typography variant="h6">Strategic Ownership</Typography>
              <Tooltip title={"This view includes all owned strategic items."}>
                <InfoOutlined sx={{ color: "grey.300", alignSelf: "center" }} />
              </Tooltip>
            </Stack>
          }
          action={<UserStrategyFilterButton userGuid={props.userGuid} />}
        />
        <Box sx={{ px: 0.5, pb: 0.5 }}>
          <UserStrategicOwnershipContent userGuid={props.userGuid} isTableView={isTableView} />
        </Box>
      </Card>
    </Stack>
  );
};

export { UserStrategicOwnershipAgendaStep };
